/** Shared error shape for slice-local errors (aligned with geolocation). */
export type SliceErrorState = {
  type: string | null;
  details?: {
    reason?: string | null;
    message?: string | null;
  } | null;
  errorCode?: number | null;
  service?: string | null;
  /** Distinguishes parse vs default when both use the same slice error bucket */
  category?: 'parse' | 'default' | null;
};

export const emptySliceError = (): SliceErrorState => ({
  type: null,
  errorCode: null,
  service: null,
  category: null,
  details: {
    message: null,
    reason: null,
  },
});
